import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';
import cx from 'classnames';

type Props = {
  className?: string;
  to: string;
  children: ReactNode;
};

export const RoundButton = (props: Props) => {
  const { children, className, to } = props;
  return (
    <StyledNavLink className={cx('btn round-button', className)} to={to}>
      {children}
    </StyledNavLink>
  );
};

const StyledNavLink = styled(NavLink)`
  font-weight: 700;
  font-size: 1.07rem;
  padding: 8px 26px;
  border-radius: 28px;
  transition: 0.3s opacity;
  opacity: 0.8;
  background: ${(props) => props.theme.splashPrimary1};
  color: ${(props) => props.theme.splashPrimary2};
  border: 2px solid ${(props) => props.theme.splashPrimary2};

  :hover {
    opacity: 1;
    color: ${(props) => props.theme.splashPrimary2};
  }
`;
